// extracted by mini-css-extract-plugin
export default {"thanksMessage":"styles_thanksMessage__zLAZR","checkbox_wrapper":"styles_checkbox_wrapper__SoEjP","checkbox_label":"styles_checkbox_label__y27Sv"};